// extracted by mini-css-extract-plugin
export default {"mainContainer":"transactionsPage_mainContainer__v58HG","innerContainer":"transactionsPage_innerContainer__4zbWI"};